// extracted by mini-css-extract-plugin
export default {"handle":"DragItem-module_handle__yy7yL","root":"DragItem-module_root___nGHJ","onDrag":"DragItem-module_onDrag__M4qYK"};